import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, P } from "../../AbstractElements";
import { BigImageApi } from "../../api";
import { PortfolioTitle } from "../../Constant";

const PhotosTab = () => {
  const description = "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
  const [smallImages, setsmallImages] = useState([]);

  useEffect(() => {
    axios.get(BigImageApi).then((response) => {
      setsmallImages(response.data.src);
    });
  }, []);

  return (
    <Fragment>
      <Row>
        {smallImages && (
          <Col sm="12">
            <Card>
              <CardBody>
                <div className="my-gallery gallery-with-description">
                  <Row>
                    <Gallery>
                      {smallImages &&
                        smallImages.map((item, i) => {
                          return (
                            <Col xl={3} sm={6} key={i}>
                              <figure>
                                <Item original={require(`../../assets/images/${item}`)} thumbnail={require(`../../assets/images/${item}`)} width="1024" height="768" caption="hello">
                                  {({ ref, open }) => (
                                    <Link onClick={open}>
                                      <img className="img-thumbnail" ref={ref} src={require(`../../assets/images/${item}`)} alt="" />
                                      <div className="caption">
                                        <H4>{PortfolioTitle}</H4>
                                        <P>{description}</P>
                                      </div>
                                    </Link>
                                  )}
                                </Item>
                              </figure>
                            </Col>
                          );
                        })}
                    </Gallery>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
    </Fragment>
  );
};
export default PhotosTab;
